import { render } from "./TableResults.vue?vue&type=template&id=1b035e9d"
import script from "./TableResults.vue?vue&type=script&lang=js"
export * from "./TableResults.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__